// extracted by mini-css-extract-plugin
module.exports = {"videoCard":"_videoCard__LB2R2","preview":"_preview__6PxEf","videoContainer":"_videoContainer__H_itu","playVideoIcon":"_playVideoIcon__e1opk"};